import type { IconSvgObject } from './types';

const Add02Icon: IconSvgObject = [
  ["path", { d: "M13.5 20.002V13.5H20L20.002 10.502H13.5V4.00195L10.502 4V10.502H4V13.5H10.502V20.002H13.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Add02Icon;
